import { render, staticRenderFns } from "./AthleteSearchResult.vue?vue&type=template&id=2b56601e&scoped=true&"
import script from "./AthleteSearchResult.vue?vue&type=script&lang=js&"
export * from "./AthleteSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56601e",
  null
  
)

export default component.exports